var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var SourceResponseValidator = function (response) {
    if (!response.source) {
        throw new ValidationError('Missing required field: source');
    }
    // Currently only Blockly JSON sources are supported.
    var blocklySource;
    try {
        blocklySource = JSON.parse(response.source);
    }
    catch (e) {
        throw new ValidationError('Error parsing JSON: ' + e);
    }
    if (blocklySource.blocks === undefined) {
        throw new ValidationError('Missing required field: blocks');
    }
    return response;
};
export var LevelPropertiesValidator = function (response) {
    if (!response.appName) {
        throw new ValidationError('Missing required field: appName');
    }
    // Convert stringified booleans to actual booleans.
    for (var _i = 0, _a = Object.keys(response); _i < _a.length; _i++) {
        var key = _a[_i];
        if (response[key] === 'true') {
            response[key] = true;
        }
        if (response[key] === 'false') {
            response[key] = false;
        }
    }
    return response;
};
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ValidationError';
        // Needed for TypeScript to register this class correctly in ES5
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
export { ValidationError };
